module.exports = __webpack_public_path__ + "static/media/bg.6523e53e.jpg";